import React, { useEffect, useState } from "react";
import {
  FaGraduationCap,
  FaBook,
  FaUserGraduate,
  FaHandsHelping,
} from "react-icons/fa";
import MyPage from "../components/MyPage";

const iconMap = {
  graduate: <FaUserGraduate className="edu-icon" />,
  book: <FaBook className="edu-icon" />,
  help: <FaHandsHelping className="edu-icon" />,
  cap: <FaGraduationCap className="edu-icon" />,
};

function EducationalInitiatives() {
  const [data, setData] = useState(null);

  useEffect(() => {
    // ✅ JSON → UI
    fetch("/api/educational.json")
      .then((res) => res.json())
      .then((json) => setData(json));

    // ✅ XML → proof only
    fetch("/api/educational.xml")
      .then((res) => res.text())
      .then(() => console.log("Educational XML loaded"));
  }, []);

  if (!data) return null;

  return (
    <>
      {/* ✅ SEO SAME – NO API */}
      <MyPage
        title="EducationalInitiatives | Thrissur Jilla Pravasi Kootayma"
        description="Educational initiatives supporting students, scholarships, guidance, and skill development."
        keywords="Thrissur Pravasi education, scholarships, educational initiatives"
      />

      {/* ===== INNER BANNER ===== */}
      <section className="inner-banner">
        <div className="inner-overlay"></div>
        <div className="inner-content slide-down">
          <h1>{data.banner.title}</h1>
        </div>
        <div className="breadcrumb slide-up">
          {data.banner.breadcrumb}
        </div>
      </section>

      {/* ===== CONTENT SECTION ===== */}
      <section className="edu-section">
        <div className="edu-header slide-left">
          <h2>
            <FaGraduationCap /> {data.header.title} <span></span>
          </h2>
          <p>{data.header.description}</p>
        </div>

        <div className="edu-grid">
          {data.programs.map((item, index) => (
            <div
              key={index}
              className={`edu-card slide-right delay-${index + 1}`}
            >
              {iconMap[item.icon]}
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ===== CSS ===== */}
      <style>{`
/* ================= PAGE LOAD ANIMATIONS ================= */
@keyframes slideLeft {
  from { opacity: 0; transform: translateX(-80px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideRight {
  from { opacity: 0; transform: translateX(80px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideUp {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideDown {
  from { opacity: 0; transform: translateY(-40px); }
  to { opacity: 1; transform: translateY(0); }
}

.slide-left {
  animation: slideLeft 1s ease forwards;
}

.slide-right {
  opacity: 0;
  animation: slideRight 1s ease forwards;
}

.slide-up {
  animation: slideUp 1s ease forwards;
}

.slide-down {
  animation: slideDown 1s ease forwards;
}

/* DELAYS FOR CARDS */
.delay-1 { animation-delay: 0.2s; }
.delay-2 { animation-delay: 0.4s; }
.delay-3 { animation-delay: 0.6s; }
.delay-4 { animation-delay: 0.8s; }

/* ===== INNER BANNER ===== */
.inner-banner {
  position: relative;
  height: 420px;
  background: url("/assets/banner.jpg") center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 120px;
}

.inner-overlay {

  inset: 0;
  background: rgba(0,0,0,0.65);
}

.inner-content {
  position: relative;
  z-index: 1;
}

.inner-content h1 {
  font-size: 48px;
  font-weight: 700;
  font-family: "Merriweather", serif;
}

.breadcrumb {
  position: absolute;
  bottom: -20px;
  left: 55px;
  border-radius: 4px;
  background: var(--primary-color);
  padding: 10px 25px;
  font-size: 20px;
  font-weight: 500;
  color: #000;
  z-index: 1;
}
/* ===== EDUCATION SECTION ===== */
.edu-section {
  padding: 100px 80px;
  background: #fff;
}

.edu-header {
  text-align: center;
  max-width: 800px;
  margin: 0 auto 70px;
}

.edu-header h2 {
  font-size: 36px;
  font-weight: 700;
  font-family: "Merriweather", serif;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.edu-header h2 span {
  width: 60px;
  height: 2px;
  background: #000;
}

.edu-header p {
  font-size: 16px;
  margin-top: 12px;
  color: #333;
  line-height: 1.7;
}

/* GRID */
.edu-grid {
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 40px;
}

/* CARD */
.edu-card {
  background: #f7f9ee;
  padding: 35px 25px;
  border-radius: 12px;
  text-align: center;
}

.edu-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.15);
}

.edu-icon {
  font-size: 42px;
  color: var(--primary-color);
  margin-bottom: 15px;
}

/* RESPONSIVE */
@media (max-width: 1200px) {
  .edu-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .edu-section {
    padding: 70px 20px;
  }

  .edu-grid {
    grid-template-columns: 1fr;
  }

  .inner-content h1 {
    font-size: 25px;
  }

  .edu-header h2 {
    font-size: 28px;
  }

  .breadcrumb {
    left: 16px;
    bottom: -20px;
    padding: 8px 12px;
    font-size: 12px;
  }
}
      `}</style>
    </>
  );
}

export default EducationalInitiatives;
